import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";
import styles from "./TextArea.module.scss";

type TextAreaResizeGripProps = ComponentPropsWithoutRef<"span">;

/** The two Figma grip lines, shared with the anatomy schematic. */
export const TextAreaGripLines = () => (
    <svg viewBox="0 0 11 11" aria-hidden>
        <line
            x1="1"
            y1="10.2929"
            x2="10.1924"
            y2="1.10051"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
        />
        <line
            x1="6"
            y1="10.2929"
            x2="10.2426"
            y2="6.05025"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
        />
    </svg>
);

/** Figma-matched vertical resize handle. */
export const TextAreaResizeGrip = ({
    className,
    ...props
}: TextAreaResizeGripProps) => (
    <span aria-hidden className={classNames(styles.grip, className)} {...props}>
        <TextAreaGripLines />
    </span>
);
